<template>
  <v-layout wrap>
    <v-flex xs12 xl8>
      <div v-if="!isMobile" class="px-2">
        <navigation-favorites
          :items="feedbackFields"
          :client-data="clientData"
          @tab-changed="setActive($event)"
        />
      </div>
      <div v-else>
        <v-tabs
          v-model="active"
          :centered="true"
          :grow="true"
          slider-color="#232C43"
        >
          <v-tab v-for="field in feedbackFields" :key="field.value">
            {{ field.text }}
          </v-tab>
        </v-tabs>
      </div>
      <div class="container-table mx-2">
        <feedback-client-data
          :table-headers="getTableHeaders"
          :table-data="homesData"
          :client-data="clientData"
          :feedback-type="feedbackTypes[active]"
          @offer-message-sent="offerMessageSent($event)"
        />
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import NavigationFavorites from '../../components/client/favorites/NavigationFavorites.vue'
import FeedbackClientData from '../../components/client/feedback/FeedbackClientData.vue'
import '../../components/icons/hw-verified_feedback-24px'

export default {
  components: { NavigationFavorites, FeedbackClientData },

  data() {
    return {
      active: 0,
      feedbackFields: [
        { value: 0, text: 'Feedback Needed', icon: 'feedback' },
        {
          value: 1,
          text: 'Feedback Provided',
          svgIcon: 'hw-verified_feedback-24px',
          size: '28'
        }
      ],
      feedbackTypes: ['needed', 'provided']
    }
  },

  computed: {
    ...mapState('client', ['clientData', 'clientFavorites']),
    ...mapState('common', ['isMobile']),
    ...mapGetters('client', ['feedbackNeededHomes', 'feedbackProvidedHomes']),

    homesData() {
      return this.active === 0 ? this.feedbackNeededHomes : this.feedbackProvidedHomes
    },

    getTableHeaders() {
      if (this.isMobile) {
        return [
          { text: 'Address', value: 'address', width: '70%', sortable: false },
          {
            text: 'Feedback',
            value: 'feedback',
            sortable: false,
            class: 'text-xs-right'
          }
        ]
      }
      const tableHeaders = [
        [
          { value: 'address', text: 'Address', sortable: false, width: '50%' },
          { value: 'showingDate', text: 'Showing Date', sortable: false },
          { value: 'pictures', text: 'Pictures', sortable: false },
          {
            value: 'offer',
            text: 'Make Offer',
            sortable: false,
            align: 'center'
          },
          {
            value: 'feedback',
            text: 'Provide Feedback',
            sortable: false,
            align: 'center'
          }
        ],
        [
          { value: 'address', text: 'Address', sortable: false, width: '50%' },
          { value: 'showingDate', text: 'Showing Date', sortable: false },
          { value: 'pictures', text: 'Pictures', sortable: false },
          {
            value: 'offer',
            text: 'Make Offer',
            sortable: false,
            align: 'center'
          },
          { value: 'feedback', text: 'View Feedback', sortable: false }
        ]
      ]
      return tableHeaders[this.active]
    }
  },

  methods: {
    ...mapMutations('client', {
      setClientData: 'SET_CLIENT_DATA',
      saveClientFavorites: 'SAVE_CLIENT_FAVORITES'
    }),

    setActive(val) {
      this.active = val
    },

    offerMessageSent(data) {
      const updatedClientFavs = this.clientFavorites.map(home => {
        return home._id === data.propertyId
          ? { ...home, ...data, favoriteId: data._id, _id: home._id }
          : home
      })
      const updatedClientHomes = this.clientData.homes.map(home => {
        return home._id === data._id ? data : home
      })
      this.setClientData({ ...this.clientData, homes: [...updatedClientHomes] })
      this.saveClientFavorites(updatedClientFavs)
    }
  }
}
</script>

<style lang="sass" scoped>
.container-table
  border-radius: 0 0 1rem 1rem
  background: $hwayzWhite
  padding: 3rem
  min-height: 40vh
  max-width: 120rem
  margin-top: -3px
  -webkit-box-shadow: 0.2rem 0.2rem 0.5rem -0.2rem rgba(0, 0, 0, 0.3)
  -moz-box-shadow: 0.2rem 0.2rem 0.5rem -0.2rem rgba(0, 0, 0, 0.3)
  box-shadow: 0.2rem 0.2rem 0.5rem -0.2rem rgba(0, 0, 0, 0.3)
  @media only screen and (max-width: 450px)
    padding: 0
    border-radius: 0
    box-shadow: none
    height: 100vh
    margin: 0 !important
</style>
